var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('navbar',{attrs:{"titleObj":_vm.titleObj,"title":_vm.title,"couponTitleVisible":false,"navbarLoginVisible":false,"navbarLogoName":"otoLogo.jpg","navbarLogoLink":"/merchant/oto","isOTOPage":true}})}
var staticRenderFns = []

export { render, staticRenderFns }